
const m = window.require("@glimmer/validator");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
